import { render, staticRenderFns } from "./Chisei_body.vue?vue&type=template&id=a65b54fe"
import script from "./Chisei_body.vue?vue&type=script&lang=js"
export * from "./Chisei_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports